/**************************************************************************************************************************
 Copyright (c) 2024 WorkEarly Results LLP

     Name: services.section.tsx
   Author: Harikrishnan Gangadharan
 Comments: 

/**************************************************************************************************************************
 IMPORTS
***************************************************************************************************************************/
import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';

import Statics from '@/constants/statics';
import BasicComponents from '@/shared/basic.components';
import Section from '@/shared/section';
/**************************************************************************************************************************
 IMPLEMENTATIONS
***************************************************************************************************************************/
const Services: FunctionComponent = () => {
  const { t } = useTranslation('home-page');

  return (
    <Section id="services" className="bg-white">
      <div className="w-full flex flex-col items-start justify-start gap-10">
        <BasicComponents.SectionHeader
          title={t('services.title')}
          subtitle={t('services.subtitle')}
        />
        <div className="w-full grid grid-cols-1 lg:grid-cols-2 gap-10">
          {Statics.ServiceItems.map(({ id, src, title, desc }, idx: number) => (
            <motion.div
              key={id}
              className="col-span-1 w-full flex flex-col items-center justify-start gap-5 overflow-hidden"
              initial="initial"
              whileInView="entry"
              viewport={{ once: true }}
              variants={{
                initial: {
                  x: 50 + idx * 25,
                  opacity: 0
                },
                entry: {
                  x: 0,
                  opacity: 1
                }
              }}
              transition={{
                duration: 0.5
              }}
            >
              <img
                src={src}
                alt="service"
                className="w-full h-[275px] object-contain transition-all duration-500"
              />
              <div className="w-full flex flex-col items-center justify-start gap-2">
                <h4 className="text-lg lg:text-xl font-aldrich font-semibold uppercase">
                  {t(title)}
                </h4>
                <p className="text-md lg:text-lg text-justify font-poppins font-light">{t(desc)}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </Section>
  );
};

export default Services;
